import React, { FC } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { Streak } from 'src/components';
import theme from 'src/utils/theme';
import { StreakType } from 'src/components/Streak';
import * as S from './styles';

const msgs = defineMessages({
  heading: {
    id: 'streaks_homepage_header',
  },
  info: {
    id: 'streaks_celebration_info',
  },
});

export const StreakModal: FC<{
  streak: StreakType;
  isOpen: boolean;
  onClose: () => void;
}> = ({ streak, isOpen, onClose }) => {
  const intl = useIntl();

  return (
    <S.ModalWrapper isOpen={isOpen} darkCloseIcon handleClose={onClose}>
      <S.Content>
        <S.CardContainer data-testid="streak-card" $borderRadius={theme.bo.mediumSmall}>
          <S.HeadingWrapper>
            <S.FireIcon name="fire" />
            <S.CardContainerHeading data-testid="streak-card-header">
              {intl.formatMessage(msgs.heading)}
            </S.CardContainerHeading>
          </S.HeadingWrapper>
          <Streak {...streak} />
        </S.CardContainer>
        <S.Description data-testid="streak-card-description">
          {intl.formatMessage(msgs.info)}
        </S.Description>
      </S.Content>
    </S.ModalWrapper>
  );
};
